"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldWrapper = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const flatArray_1 = require("../../../../utils/flatArray");
const Icon_1 = require("../../../Icon");
const Tooltip_1 = require("../Tooltip");
require("./index.scss");
const className = 'form-field';
const FormFieldWrapper = (props) => {
    const { style: propsStyle = {}, addonWidth = '46px', onClick, error, info, tooltipIconHidden, label, prefix, prefixIcon, addon, addonIcon, additionClassNames, modificators, required, inputSlot, slot, } = props;
    const style = { '--addon-width': addonWidth, ...propsStyle };
    const infos = (0, flatArray_1.flatArray)(info);
    const errors = (0, flatArray_1.flatArray)(error);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        errors ? 'error' : undefined,
        required ? 'required' : undefined,
    ], additionClassNames);
    return (react_1.default.createElement("div", { className: classNames, style: style, onClick: onClick },
        react_1.default.createElement("label", { className: `${className}__container` },
            react_1.default.createElement(Tooltip_1.FormFieldTooltip, { info: info, error: error }),
            label && (react_1.default.createElement("div", { className: `${className}__label` },
                react_1.default.createElement("span", null, label),
                react_1.default.createElement("u", null))),
            prefix && (react_1.default.createElement("div", { className: `${className}__prefix` }, prefix)),
            prefixIcon && (react_1.default.createElement("div", { className: `${className}__prefix` },
                react_1.default.createElement(Icon_1.Icon, { name: prefixIcon }))),
            react_1.default.createElement("div", { className: `${className}__content` },
                slot,
                inputSlot && (react_1.default.createElement("div", { className: `${className}__input` }, inputSlot))),
            (!(0, flatArray_1.flatArray)([infos, errors]) || tooltipIconHidden) ? undefined : (react_1.default.createElement("div", { className: `${className}__tooltip-icon` },
                react_1.default.createElement(Icon_1.Icon, { name: 'info-circle-filled' }))),
            addon && (react_1.default.createElement("div", { className: `${className}__addon` }, addon)),
            addonIcon && (react_1.default.createElement("div", { className: `${className}__addon` },
                react_1.default.createElement(Icon_1.Icon, { name: addonIcon }))))));
};
exports.FormFieldWrapper = FormFieldWrapper;
//# sourceMappingURL=index.js.map